import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Chromium peut émettre cette erreur non bloquante quand ResizeObserver se déclenche
// dans la même frame qu’un reflow (Radix Select, Popover, etc.) — l’overlay CRA ne doit pas la traiter comme un crash.
if (typeof globalThis !== "undefined" && process.env.NODE_ENV === "development") {
  const resizeObserverMsgs = new Set([
    "ResizeObserver loop completed with undelivered notifications.",
    "ResizeObserver loop limit exceeded",
  ]);
  globalThis.addEventListener(
    "error",
    (e) => {
      if (resizeObserverMsgs.has(e.message)) {
        e.stopImmediatePropagation();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
